import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

import type { TFeaturedIconColor } from 'libs/design-system/src/types/featured_icon/featuredIcon';
import { CircleInfo } from '@unified-checkout/design-system/icons/index';
import { Badge, FeaturedIcon } from '@unified-checkout/design-system';

import type { ITransferDetailsHeader } from '@app/dashboard/types/innerLayout/balance_and_transfers/single-transfer';

import { TRANSFER_BADGES } from '@app/dashboard/constants/balance_and_transfers/transfers/transfer-badges';

import styles from './transfer-badge.module.scss';

const TransferBadge = ({
  header,
}: {
  header: ITransferDetailsHeader | undefined;
}) => {
  const { t } = useTranslation();

  const badges = useMemo(() => TRANSFER_BADGES(t), [t]);

  const badge = header && badges[header.status.key as keyof typeof badges];

  return (
    <div
      className={styles['transfer-badge']}
      data-transfer-badge-status={header?.status.key}
    >
      <Badge
        leadingIcon={
          <FeaturedIcon
            icon={badge?.icon || CircleInfo}
            color={(badge?.color as TFeaturedIconColor) || 'primary'}
            size="xs"
            variant="contained"
          />
        }
        text={badge?.text || header?.status.label || ''}
        color={(badge?.color as TFeaturedIconColor) || 'primary'}
        size="sm"
      />
    </div>
  );
};

export default TransferBadge;
